var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMatchStoppedInjury(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    x1: 19.64,
    y1: 41.52,
    x2: 25.48,
    y2: 41.52,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.58,48H5.51a3.26,3.26,0,0,1-3.26-3.26h0a3.26,3.26,0,0,1,3.26-3.26h4.84",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.53,
    cy: 8.07,
    r: 6.22,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,23.2a2.39,2.39,0,0,1-.37,1.27l-3.29,5.26-.73,1.19-.14,0L26.11,34.51a2.41,2.41,0,1,1-1.25-4.65l11.67-3.12,3-4.82A2.41,2.41,0,0,1,44,23.2Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.62,
    y1: 30.92,
    x2: 39.48,
    y2: 30.95,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.35,
    y1: 29.73,
    x2: 39.62,
    y2: 30.92,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.19,33.78l7.38,5.52a24.91,24.91,0,0,1,2.93.08,28.28,28.28,0,0,1,2.82.39",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.93,48.15c-2.72-2.17-5.49-4.58-8.26-7.28-.73-.71-1.44-1.43-2.13-2.14L14.18,47.1a3.26,3.26,0,0,1-4.62-4.61q5.2-5.43,10.83-10.89l1-.94a2.63,2.63,0,0,1,2.73-.56,3,3,0,0,1,.66.36",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.54,28.07l1-6.35a5,5,0,0,1,1.35-2.94,5.3,5.3,0,0,1,1.69-1.12,6,6,0,0,1,2.6-.47l4.22.47a5.11,5.11,0,0,1,4.53,5.64L45,40.93A7.81,7.81,0,0,1,44,44a8.56,8.56,0,0,1-4.74,3.71,6.74,6.74,0,0,1-1.93.3,75.34,75.34,0,0,1-8.28,0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.7,
    y1: 34.91,
    x2: 26.86,
    y2: 42.94,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.96,
    y1: 27.1,
    x2: 39.34,
    y2: 30.71,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24 14.34 24 18.74 18.5 18.74 18.5 24.23 14.11 24.23 14.11 18.74 8.61 18.74 8.61 14.34 14.11 14.34 14.11 8.85 18.5 8.85 18.5 14.34 24 14.34",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchStoppedInjury);
export default __webpack_public_path__ + "static/media/MATCH_STOPPED_INJURY.6cc3bfd03e0443ce91826e42b669a10f.svg";
export { ForwardRef as ReactComponent };